// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_ms-0";
export var animationContainer = "_ms-1";
export var itemPrice = "_ms-a";
export var itemizedContent = "_ms-9";
export var itemizedHeader = "_ms-7";
export var itemizedRow = "_ms-8";
export var itemizedSection = "_ms-6";
export var modalContent = "_ms-2";
export var orderName = "_ms-3";
export var refundOption = "_ms-4";
export var refundOptionsContainer = "_ms-5";
export var shippingLabel = "_ms-b";
export var totalRow = "_ms-c";